module.exports = __webpack_public_path__ + "static/media/razorpay-logo-white.398c7922.png";